function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { asyncToGenerator as _asyncToGenerator } from "../../_virtual/_rollupPluginBabelHelpers.js";
import { useCallback } from 'react';
import useDocumentsAppConfigs from "../useDocumentsAppConfigs.js";
import AnnotationField from "../../stores/AnnotationField.js";
import "../../types/index.js";
import { useMutation } from 'react-query';
import SignatureResource from "./resources/SignatureResource.js";
import DocumentPartyResource from "./resources/DocumentPartyResource.js";
import DocumentFieldManualDataResource from "./resources/DocumentFieldManualDataResource.js";
import DocumentFieldSigningDataResource from "./resources/DocumentFieldSigningDataResource.js";
import DocumentResource from "./resources/DocumentResource.js";

var processManualData = function processManualData(fields) {
  return fields.map(function (field) {
    var _field$data$value;

    var manualDataResource = new DocumentFieldManualDataResource({
      id: field.data.id
    });
    manualDataResource.isPersisted = true;
    manualDataResource.value = (_field$data$value = field.data.value) === null || _field$data$value === void 0 ? void 0 : _field$data$value.toString();
    manualDataResource.fontSize = field.data.fontSize;
    return manualDataResource;
  });
};

var processSigningData = function processSigningData(fields) {
  return fields.map(function (field) {
    var signingDataResource = new DocumentFieldSigningDataResource({
      id: field.data.id
    });
    signingDataResource.isPersisted = true;
    signingDataResource.signedAt = new Date().toISOString();
    signingDataResource.fontSize = field.data.fontSize;
    return signingDataResource;
  });
};

var makeRequest = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var documentId, fields, currentUserId, currentUserPermissions, signature, currentUserFields, documentPartyResource, fieldsByDataType, documentResource;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            documentId = _ref.documentId, fields = _ref.fields, currentUserId = _ref.currentUserId, currentUserPermissions = _ref.currentUserPermissions, signature = _ref.signature;
            currentUserFields = AnnotationField.getAssignedFields(fields, currentUserId, currentUserPermissions);

            if (currentUserFields.length) {
              _context.next = 4;
              break;
            }

            throw new Error('Current user does not have any submittable fields');

          case 4:
            documentPartyResource = new DocumentPartyResource({
              signature: new SignatureResource(signature)
            });
            fieldsByDataType = AnnotationField.groupFieldsByDataType(fields, currentUserId, currentUserPermissions, true);
            documentResource = new DocumentResource({
              id: documentId,
              manualData: processManualData(fieldsByDataType.manual),
              signingData: processSigningData(fieldsByDataType.signing),
              parties: [documentPartyResource]
            });
            documentResource.isPersisted = true;
            _context.next = 10;
            return documentResource.save({
              with: ['manualData', 'signingData', {
                parties: 'signature'
              }]
            });

          case 10:
            return _context.abrupt("return", documentResource);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function makeRequest(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useUpdateDocument = function useUpdateDocument() {
  var _useDocumentsAppConfi = useDocumentsAppConfigs(),
      currentUserId = _useDocumentsAppConfi.currentUserId,
      currentUserPermissions = _useDocumentsAppConfi.currentUserPermissions;

  var _useMutation = useMutation(makeRequest),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      mutate = _useMutation2[0],
      _useMutation2$ = _useMutation2[1],
      isLoading = _useMutation2$.isLoading,
      updatedDocument = _useMutation2$.data,
      error = _useMutation2$.error;

  var updateDocument = useCallback(function (_ref3) {
    var documentId = _ref3.documentId,
        fields = _ref3.fields,
        signature = _ref3.signature;
    return mutate({
      documentId: documentId,
      fields: fields,
      currentUserId: currentUserId,
      currentUserPermissions: currentUserPermissions,
      signature: signature
    });
  }, [mutate, currentUserId, currentUserPermissions]);
  return {
    isLoading: isLoading,
    updatedDocument: updatedDocument,
    updateDocument: updateDocument,
    error: error
  };
};

export default useUpdateDocument;
export { processManualData, processSigningData };